export const isNotFoundSpaceError = (error: Error): boolean =>
	error.message?.includes('Cannot find space');

/** Gateway account-type rejections do not describe permission to read the page itself. */
export const isUnsupportedCustomerAccountFieldError = (error: {
	path?: ReadonlyArray<string | number> | null;
	extensions?: Record<string, unknown>;
}): boolean => {
	const { extensions, path } = error;
	if (
		extensions?.errorSource !== 'GRAPHQL_GATEWAY' ||
		extensions.classification !== 'CustomerAccountsNotSupportedException' ||
		String(extensions.statusCode) !== '403'
	) {
		return false;
	}
	return (
		(extensions.service === 'knowledge_discovery' &&
			(!path?.length || path[0] === 'knowledgeDiscovery')) ||
		(extensions.service === 'confluence_analytics' &&
			(!path?.length || path[0] === 'contentAnalyticsViewers'))
	);
};
